module.exports = __webpack_public_path__ + "img/3.0bcc8ab0.svg";